import { Text, Timeline } from '@mantine/core';
import { IconHistory } from '@tabler/icons-react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import useFetchInitialBalancesAudit from 'src/Hooks/Queries/useFetchInitialBalancesAudit';

import styles from './InitialBalancesAuditList.module.scss';

const formatAmount = (amount: number): string =>
  amount.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });

const InitialBalancesAuditList = () => {
  const { t } = useTranslation();
  const { data } = useFetchInitialBalancesAudit();

  if (!data || data.length === 0) return null;

  return (
    <div className={styles.container}>
      <Text fw={600} mb="sm">
        {t('expenses.initialBalancesAudit.title', 'Historique des modifications')}
      </Text>
      <Timeline active={data.length} bulletSize={20} lineWidth={2}>
        {data.map(audit => (
          <Timeline.Item
            key={audit.id}
            bullet={<IconHistory size={12} />}
            title={`${audit.firstName} ${audit.lastName}`}
          >
            <Text size="xs" c="dimmed">
              {t('expenses.initialBalancesAudit.meta', 'Modifié par {{name}} le {{date}}', {
                name: `${audit.modifiedByFirstName} ${audit.modifiedByLastName}`,
                date: dayjs(audit.modifiedAt).format('DD/MM/YYYY HH:mm'),
              })}
            </Text>
            <Text size="sm">
              <span className={styles.diffOld}>{formatAmount(audit.previousAmount)}</span>
              {' → '}
              <span className={styles.diffNew}>{formatAmount(audit.newAmount)}</span>
            </Text>
            <Text size="xs" fs="italic" c="dimmed">
              {audit.reason}
            </Text>
          </Timeline.Item>
        ))}
      </Timeline>
    </div>
  );
};

export default InitialBalancesAuditList;
